import { useState } from "react";
import ExistingUserApplication from "../../shared/ExistingUserApplication";
import { useError } from "../../context/ErrorProvider";
import { FileText, ShieldCheck } from "lucide-react";

const AcceptTerms = ({
  closeTermsAndConditions,
  activeIndex,
  handleNextStep,
  loading,
}) => {
  const [agreed, setAgreed] = useState(false);
  const { showError } = useError();

  const onProceed = () => {
    if (agreed) {
      handleNextStep();
    } else {
      showError("Please agree to the terms before proceeding.");
    }
  };
  return (
    <ExistingUserApplication
      closeBioInformation={closeTermsAndConditions}
      activeIndex={activeIndex}
      handleNextStep={onProceed}
      loading={loading}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a New Loan Application
      </p>
      <div class="w-full">
        <div class="bg-white rounded-2xl">
          <h1 class="text-2xl font-bold mb-6">Loan Application Agreement</h1>
          <p class="text-gray-700 text-sm leading-relaxed mb-6">
            Before applying for a loan, please review and accept the following
            documents. They will open in a new window so you can read them
            fully.
          </p>
          <div class="space-y-4 mb-8">
            <a
              href="https://helacred.anansitechnology.com/dashboard/terms-conditions"
              target="_blank"
              rel="noreferrer"
              class="block w-full rounded-lg border px-[15px] border-gray-300 py-3 font-medium hover:bg-gray-50 text-indigo-700"
            >
              📄 Terms & Conditions
            </a>
            <a
              href="https://helacred.anansitechnology.com/dashboard/privacy-policy"
              target="_blank"
              rel="noreferrer"
              class="block w-full rounded-lg border px-[15px] border-gray-300 py-3 font-medium hover:bg-gray-50 text-indigo-700"
            >
              🔒 Privacy Policy
            </a>
            <a
              href="https://helacred.anansitechnology.com/dashboard/debt-acknowledgement"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 w-full rounded-lg border px-[15px] border-gray-300 py-3 font-medium hover:bg-gray-50 text-indigo-700"
            >
              <FileText size={18} />
              Debt acknowledgement
            </a>

            <a
              href="https://helacred.anansitechnology.com/dashboard/data-protection"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 w-full rounded-lg border px-[15px] border-gray-300 py-3 font-medium hover:bg-gray-50 text-indigo-700"
            >
              <ShieldCheck size={18} />
              Data protection
            </a>
            <a
              href="https://helacred.anansitechnology.com/dashboard/loan-affidavit"
              target="_blank"
              rel="noreferrer"
              class="block w-full rounded-lg border px-[15px] border-gray-300 py-3 font-medium hover:bg-gray-50 text-indigo-700"
            >
              🖊 Loan Affidavit
            </a>
          </div>

          <form id="loanForm" class="space-y-6">
            <label class="flex items-start gap-3">
              <input
                type="checkbox"
                id="agree"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                className="mt-1 h-3 w-3 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              />
              <span class="text-sm text-gray-700 leading-snug">
                I confirm that I have read and agreed to the&nbsp;
                <a
                  href="https://helacred.anansitechnology.com/dashboard/terms-conditions"
                  target="_blank"
                  rel="noreferrer"
                  class="text-indigo-700 underline"
                >
                  Terms & Conditions
                </a>
                ,&nbsp;
                <a
                  href="https://helacred.anansitechnology.com/dashboard/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                  class="text-indigo-700 underline"
                >
                  Privacy Policy
                </a>
                , and will execute the&nbsp;
                <a
                  href="https://helacred.anansitechnology.com/dashboard/loan-affidavit"
                  target="_blank"
                  rel="noreferrer"
                  class="text-indigo-700 underline"
                >
                  Loan Affidavit
                </a>
                .
              </span>
            </label>
          </form>
        </div>
      </div>
    </ExistingUserApplication>
  );
};

export default AcceptTerms;
